<template>
    <div class="favorites">
        <h1 v-if="!user">Избранное</h1>

        <template v-if="!$fetchState.pending">
            <div class="catalog-offers-grid" v-if="offers.length">
                <offer v-for="offer of offers" :key="offer.id" :item="offer"></offer>
            </div>
            <div class="unavailable-message" v-else>
                Список пуст
            </div>
            <pagination v-if="pageCount > 1" :page-count="pageCount" :value="page" @input="loadMore($event)"></pagination>

        </template>
        <div class="unavailable-message" v-else>
            Загрузка
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    head: () => ({
        title: 'Избранное - Интернет-магазин мебели «ТриЯ»',
        meta: [{
            name: 'robots',
            value: 'noindex, nofollow',
        }],
    }),
    components: {
        ordersMenu: require("~/components/pages/personal/menu").default,
        Offer: require('~/components/catalog/offer').default,
        pagination: require('~/components/catalog/pagination').default,
    },
    data: () => ({offers: [], page: 1, pageCount: 1}),
    computed: mapState(['user']),
    breadcrumbs(ctx) {

        if (ctx.store.state.user) {
            return [
                {link: '/personal', name: 'Личный кабинет'},
                {link: '/personal/favories', name: 'Избранное'},
            ];
        }

        return [{link: '/personal/favories', name: 'Избранное'},];
    },
    async fetch() {
        const data = await this.$store.dispatch('catalog/GetFavoriteList', {
            page: this.page
        });
        this.offers = data.offers;
        this.pageCount = data.pageCount;
    },
    methods: {
        loadMore(page) {
            this.page = page;
            this.$fetch();
        }
    }
}
</script>

<style scoped>
.catalog-offers-grid, .pagination {
    margin-bottom: 25px;
}
</style>
